<template>
	<div class="page-link-button">
		<router-link :to="link" class="link">
			詳しくみる
		</router-link>
	</div>
</template>

<script>
export default {
	name: 'page-link-button',
	props: {
		link: String,
	},
};
</script>

<style lang="scss" scoped>
.page-link-button {
	display: inline-block;
	max-width: 240px;
	width: 100%;
}
.link {
	display: block;
	background-color: #543193;
	color: #fff;
	font-family: 'Noto Sans JP';
	width: 100%;
	text-align: center;
	font-size: 13px;
	border-radius: 100vmax;
	font-weight: bold;
	position: relative;
	line-height: 3.5em;
	&:after {
		content: '';
		background-image: url('../../assets/home/arrow.svg');
		height: 1.2em;
		width: 1.2em;
		position: absolute;
		display: block;
		background-repeat: no-repeat;
		right: 30px;
		top: 50%;
		transform: translateY(-50%);
	}
}
</style>
